angular.module('omega').service('SearchProfileService', function (API_BASE_URL, $rootScope, $http, SimplifyService) {

    this.list = function () {
        return $http.get(API_BASE_URL + 'getOmegaConfig.xqy')
            .then(function (searchProfiles) {
                // we save searchProfiles in $rootScope because it's part of config and can be used by other services
                $rootScope.searchProfiles = SimplifyService.simplifySearchProfileList(searchProfiles);
                return $rootScope.searchProfiles;
            });
    };

});